// Insider is a native-only mobile SDK; web has no integration.
export const initInsider = () => {}
export const identifyInsiderUser = (_email?: string, _userId?: string | number) => {}
export const logoutInsiderUser = () => {}
